<template>
    <div>
        <v-layout wrap align-center>
            <v-flex xs12 sm3 d-flex class="pa-2">
                <v-select @change="$refs.bracket.clear()" :items="[4, 8, 16, 32]" label="X" v-model="x"/>
            </v-flex>
        </v-layout>
        <bracket-item ref="bracket" :teams="teams" root/>
    </div>
</template>

<script>
    import BracketItem from "@/components/BracketItem";

    export default {
        name: "Bracket",
        components: {BracketItem},
        data() {
            return {
                x: 16
            }
        },
        computed: {
            teams() {
                let teams = [];
                for (let i=0; i<this.x; i++) {
                    teams.push({ name: `${i+1}` })
                }
                return teams
            }
        }
    }
</script>

<style scoped>

</style>